<template>
  <div>
    <h1 v-text="translate.trans('questionnaire.title')"></h1>
    <DateRangePicker
      v-model="dateRange"
      opens="right"
      :locale-data="locale"
      time-picker
      time-picker24hour
    ></DateRangePicker>
    <div class="d-flex">
      <BFormSelect
        v-model="selectedStatus"
        :options="options"
      ></BFormSelect>
      <BFormInput
        v-model="searchName"
        class="ml-3"
        placeholder="Search questionnaire name"
      ></BFormInput>
    </div>

    <div class="mt-3">
      <BButton @click="openPopupAddQuestionnaire">Add Questionnaire</BButton>
    </div>
    <div class="row mt-3">
      <div class="col-lg-12 col-md-8 col-sm-12 col-12 pb-5">
        <div class="orders">
          <div class="box table-area table-products overflow-x">
            <BTable
              sort-icon-left
              responsive="sm"
              :items="listQuestionnareToSort"
              :fields="fields"
              sort-by="questionnaire_in_customize_language_created_date"
              :sort-desc="true"
            >
              <template v-slot:cell(is_active)="data">
                <div class="left" style="width: 80px">
                  <div class="auto direction-ltr">
                    <label class="switch">
                      <input
                        type="checkbox"
                        :checked="data.item.is_active"
                        @change="toggleActiveQuesionnaire(data.item)"                        
                      />
                      <span class="slider round"></span>
                      <strong>{{ translate.trans("users.list.active") }}<em></em
                      ></strong>
                    </label>
                  </div>
                </div>
              </template>

              <template v-slot:cell(actions)="data">
                <div 
                  :key="data"
                  class="p-2 d-flex">
                  <!-- <button
                    title="Remove"
                    class="remove-button"
                    @click="removeQuestionnare(data.item)"></button> -->
                  <button
                    title="Edit"
                    class="edit-button ml-2"
                    @click="callGetQuestionnaireDetails(data.item.questionnaire_id)">
                  </button>
                  <!-- <button
                    title="Add"
                    class="add-button ml-2"
                    @click="openPopupAddQuestion(data.item)"></button> -->
                </div>
              </template>
            </BTable>
          </div>
        </div>
      </div>
    </div>

    <BModal 
      id="modal-center" 
      v-model="formModal.isOpen"
      size="lg" 
      centered scrollable
      :title="`${formModal.typeModal} Questionnaire`">
      <div
        class="row ml-05 mr-05 text-bold">
        <p class="ts-l flex-1">{{ translate.trans('questionnaire.name') }}</p>        
        <p class="ts-l w-20pc">{{ translate.trans('questionnaire.language') }}</p>
        <div class="row w-10pc">

        </div>
      </div>
      <div
        v-for="(questItem, id1) in formModal.questionnaireLangList" 
        :key="'t' + id1"
        class="row ml-05 mr-05 mt-05">
        <BFormInput 
          v-model="questItem.title"
          class="flex-1 mr-05">
        </BFormInput>        
        <BFormInput 
          v-model="questItem.language"
          :disabled="questItem.language === 'en'" 
          class="w-20pc">
        </BFormInput>
        <div           
          class="row w-10pc">
          <button
            v-if="questItem.language !== 'en'"
            title="Delete"
            class="remove-x-button ml-20"
            @click="deleteQuestionnaireLanguage(questItem.language)">
          </button>
        </div>
      </div>
      <button
        title="Add"
        class="add-button ml-10 mt-10"
        @click="addNewQuestionnaireLanguage"></button>
      <div class="row ml-05 mr-05 mt-20 text-bold">
        <p class="flex-2 ts-l">{{ translate.trans('questionnaire.quesDescription') }}</p>                  
        <p class="flex-1 ts-l mr-05">{{ translate.trans('questionnaire.language') }}</p>                  
      </div>
      <div
        v-for="(questItem2, id2) in formModal.questionnaireLangList" 
        :key="'d' + id2"
        class="row ml-05 mr-05 mt-05">
        <BFormInput 
          v-model="questItem2.description"
          class="flex-2 mr-05">
        </BFormInput>        
        <BFormInput 
          v-model="questItem2.language"
          disabled
          class="flex-1">
        </BFormInput>        
      </div>
      <p class="ml-05 mr-05 mt-20 ts-l text-bold">{{ translate.trans('questionnaire.questionList') }}</p>
      <draggable
        v-model="formModal.questionnaireLangList[0].questions"
        @end="onQuestionEndOrder">
        <div 
          v-for="(item, idx) in formModal.questionnaireLangList[0].questions"
          :key="'s' + idx"
          class="row ml-05 c-items full-w">
          <div 
            v-for="(ques, pos) in formModal.questionnaireLangList"
            :key="'l' + pos"
            class="row c-items ml-10 mr-10 mt-05 full-w">
              <p v-if="pos === 0" class="w-05pc">{{ idx + 1 }}</p>
              <p v-else class="w-05pc">{{ " " }}</p>
              <BFormInput             
                v-model="formModal.questionnaireLangList[pos].questions[idx].content"
                class="flex-1 ml-05">
              </BFormInput>
              <BFormInput             
                v-model="formModal.questionnaireLangList[pos].language"
                class="w-10pc ml-05"
                disabled>
              </BFormInput>
              <div class="w-10pc">
                <button
                  v-if="formModal.questionnaireLangList[pos].language === 'en'"
                  title="Delete"
                  class="remove-x-button ml-20"
                  @click="deleteQuestion(formModal.questionnaireLangList[pos].questions[idx].id, formModal.questionnaireLangList[pos].questions[idx].index)">
                </button>
              </div>
          </div>
        </div>
      </draggable>
      <button
        title="Add"
        class="add-button ml-10 mt-10"
        @click="addNewQuestion"></button>
      <template v-slot:modal-footer>
        <div class="w-100 d-flex center">
          <div class="btn-primary" @click="addEditModalSubmit">
            {{ formModal.typeModal === "New" ? 'Add Questionnaire' : 'Save' }}
          </div>
        </div>
      </template>
    </BModal>    
  </div>
</template>

<script>
import {
  BTable,
  // BFormDatepicker,
  // BInputGroup,
  BFormInput,
  // BInputGroupAppend,
  BFormSelect,
  BModal,
  BButton,
} from "bootstrap-vue";
import DateRangePicker from "vue2-daterange-picker";
import draggable from 'vuedraggable';
import DibbleTranslation from "../../translation/translation";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DibbleAPI from '../../api';
import DibbleJS from '../../dibble';

export default {
  name: "AppReportsPage",
  components: {
    BFormSelect,
    BTable,
    // BFormDatepicker,
    // BInputGroup,
    BFormInput,
    // BInputGroupAppend,
    BModal,
    BButton,
    DateRangePicker,
    draggable,
  },
  data() {
    return {
      translate: DibbleTranslation,      
      fields: [
        {
          key: "questionnaire_id",
          label: "Questionnaire Number",
          sortable: true,
        },
        {
          key: "subject",
          label: `${DibbleTranslation.trans("questionnaire.subject")}`,
          sortable: true,
        },
        // {
        //   key: "questionnaire_name",
        //   label: `${DibbleTranslation.trans("questionnaire.name")}`,
        //   sortable: true,
        // },
        {
          key: "description",
          label: `${DibbleTranslation.trans("questionnaire.description")}`,
          sortable: true,
        },
        {
          key: "num_of_questions",
          label: "Number of questions",
          sortable: true,
        },
        {
          key: "created_on",
          label: "Date of creation",
          sortable: true,
          formatter: (value) => {
            return value ? this.$moment(value).format("DD/MM/YY") : "";
          },
        },
        { key: "is_active", label: "Is Active" },                
        // {
        //   key: "percentage_filled",
        //   label: "Percentage Filled",
        //   sortable: true,
        // },
        { key: "actions", label: "Actions" },
      ],
      listQuestionnare: [],
      listQuestionnareToSort: [],
      dateRange: {
        startDate: null,
        endDate: null,
      },
      locale: {
        format: "dd/mm/yy HH:MM",
      },
      selectedStatus: null,
      options: [
        { value: null, text: "Please select a status" },
        { value: true, text: "Active" },
        { value: false, text: "Unactive" },
      ],
      searchName: "",
      formModal: {
        isOpen: false,
        typeModal: "New",        
        questionnaire_id: 0,        
        questionnaireLangList: [
          {
            id: 1,
            title: "",
            description: "",
            language: "en",
            questions: [
              {
                id: 1,
                content: "",
                index: 1
              }
            ]
          }
        ]
      },
      questionnaireICL: {}
    };
  },
  watch: {
    dateRange(value) {
      this.handleSearch(value, this.selectedStatus, this.searchName);
    },
    selectedStatus(value) {
      this.handleSearch(this.dateRange, value, this.searchName);
    },
    searchName(value) {
      this.handleSearch(this.dateRange, this.selectedStatus, value);
    },
  },
  mounted() {
    this.getListQuestionnare();
  },
  methods: {
    getListQuestionnare() {
      const rq = {
        "#request" : DibbleAPI.api.questionnaire.getAll
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()
          if (DibbleAPI.isResponseSuccess(data)) {
            this.listQuestionnare = data.questionnaires
            this.listQuestionnareToSort = data.questionnaires
          } else {
            DibbleAPI.toastErrorMessage(data.message)
          }
        }
      )
    },
    callGetQuestionnaireDetails (questionnaireId) {
      const rq = {
        "#request" : DibbleAPI.api.questionnaire.getQuestionnaireDetails,
        questionnaire_id: questionnaireId
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()
          if (DibbleAPI.isResponseSuccess(data)) {            
            this.openPopupEditQuestionnaire(data)
          } else {
            DibbleAPI.toastErrorMessage(data.message)
          }
        }
      )
    },    
    addNewQuestionnaireLanguage () {
      const newLangQues = JSON.parse(JSON.stringify(this.formModal.questionnaireLangList[this.formModal.questionnaireLangList.length-1]));
      newLangQues.id = this.formModal.questionnaireLangList.length;
      newLangQues.language = "";
      newLangQues.title = "";
      newLangQues.description = "";
      // eslint-disable-next-line array-callback-return
      newLangQues.questions.map ((item, pos) => {
        newLangQues.questions[pos].content = ""
      })
      this.formModal.questionnaireLangList.push(newLangQues);
    },
    addNewQuestion () {
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList.map((item, index) => {
        const question = JSON.parse(JSON.stringify(this.formModal.questionnaireLangList[index].questions[this.formModal.questionnaireLangList[index].questions.length-1]))
        question.id = "0"
        question.content = ""
        question.index = item.questions.length
        this.formModal.questionnaireLangList[index].questions.push(question)
        // this.formModal.questionnaireLangList[index].questions[this.formModal.questionnaireLangList[index].questions.length-1].id = "0"
      })
      console.log("addNewQuestion: " + JSON.stringify(this.formModal.questionnaireLangList))
    
    },
    addEditModalSubmit () {
      if(this.formModal.typeModal === "New") {
        this.callAddQuestionnaireApi()
      } else {
        this.callUpdateQuestionnaireApi()
      }
    },
    callAddQuestionnaireApi () {
      const titles = []
      const descriptions = []
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList.map((item) => {
        const itemTitle = {
          lang: item.language,
          text: item.title          
        }
        const itemDes = {
          lang: item.language,
          text: item.description          
        }
        titles.push(itemTitle)
        descriptions.push(itemDes)
      })      
      const rq = {
        "#request": DibbleAPI.api.questionnaire.addQuestionnaire,
        subject: titles,
        description: descriptions
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()          
          if (DibbleAPI.isResponseSuccess(data)) {
            this.callAddQuestionApi(data.questionnaire_id)
            DibbleJS.toastSuccessMessage(data.message)            
            this.closePopupAddQuestion()
            this.getListQuestionnare()
          } else {
            DibbleJS.toastErrorMessage(data.message)
          }
        }
      )
    },
    callUpdateQuestionnaireApi () {
      const titles = []
      const descriptions = []
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList.map((item) => {
        const itemTitle = {
          lang: item.language,
          text: item.title          
        }
        const itemDes = {
          lang: item.language,
          text: item.description          
        }
        titles.push(itemTitle)
        descriptions.push(itemDes)
      })      
      const rq = {
        "#request": DibbleAPI.api.questionnaire.updateQuestionnaire,
        questionnaire_id: this.formModal.questionnaire_id,
        subject: titles,
        description: descriptions
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()          
          if (DibbleAPI.isResponseSuccess(data)) {
            this.closePopupAddQuestion()
            this.callUpdateQuestionApi(this.formModal.questionnaire_id)
            this.callSetQuestionOrder()
            DibbleJS.toastSuccessMessage(data.message)            
            this.getListQuestionnare()
          } else {
            DibbleJS.toastErrorMessage(data.message)
          }
        }
      )
    },
    callAddQuestionApi (questionId) {
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList[0].questions.map((questListInOneLange, index) => {
        const questions = []
        // eslint-disable-next-line array-callback-return
        this.formModal.questionnaireLangList.map((item, pos) => {
          questions.push({
            lang: item.language,
            text: item.questions[index].content
          })
        })
        const rq = {
          "#request" : DibbleAPI.api.questionnaire.addQuestion,
          questionnaire_id: questionId,
          question: questions
        }
        DibbleJS.callApiRequest(
          rq,
          (data) => {
            console.log("addQuestion: " + JSON.stringify(data))            
          }
        )
      })
    },
    callUpdateQuestionApi (questionnaireId) {
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList[0].questions.map((questionItem, index) => {
        const questions = []
        // eslint-disable-next-line array-callback-return
        this.formModal.questionnaireLangList.map((item, pos) => {
          questions.push({
            lang: item.language,
            text: item.questions[index].content
          })
        })
        if (questionItem.id === "0") {
          const rq = {
            "#request" : DibbleAPI.api.questionnaire.addQuestion,
            questionnaire_id: questionnaireId,            
            question: questions
          }
          DibbleJS.callApiRequest(
            rq,
            (data) => {
              console.log("addQuestion: " + JSON.stringify(data))            
            }
          )
        } else {
          const rq = {
            "#request" : DibbleAPI.api.questionnaire.updateQuestion,
            questionnaire_id: questionnaireId,
            question_id: questionItem.id,
            question: questions
          }
          DibbleJS.callApiRequest(
            rq,
            (data) => {
              console.log("addQuestion: " + JSON.stringify(data))            
            }
          )
        }
      })
    },
    deleteQuestionnaireLanguage (language) {
      DibbleJS.confirmBox(this.translate.trans("dashboard.modals.save.are_you_sure"), () => {
        let deletePos = -1;
        // eslint-disable-next-line array-callback-return
        this.formModal.questionnaireLangList.map((item, index) => {
          if (language === item.language) {
            deletePos = index
          }
        })
        if (deletePos > -1) {
          this.formModal.questionnaireLangList.splice(deletePos, 1)
        }
      })
    },
    deleteQuestion (questionId, index) {
      if (questionId === "0" || questionId === 0) {
        // eslint-disable-next-line array-callback-return
        this.formModal.questionnaireLangList.map((item,idxL) => {
          // eslint-disable-next-line array-callback-return
          item.questions.map((questionItem, idx) => {
            if (questionItem.id === questionId && questionItem.index === index) {
              item.questions.splice(idx, 1)
            }
          })
        })
      } else {
        DibbleJS.confirmBox(this.translate.trans("dashboard.modals.save.are_you_sure"), () => {
          DibbleJS.showLoader()
          const rq = {
            "#request": DibbleAPI.api.questionnaire.deleteQuestion,
            questionnaire_id: this.formModal.questionnaire_id,
            question_id: questionId
          }
          DibbleJS.callApiRequest(
            rq,
            (data) => {
              DibbleJS.hideLoader()
              if (DibbleAPI.isResponseSuccess(data)) {
                DibbleJS.toastSuccessMessage(data.message)
                this.callGetQuestionnaireDetails(this.formModal.questionnaire_id)
              } else {
                DibbleJS.toastErrorMessage(data.message)
              }
            }
          )
        })
      }
    },
    onQuestionEndOrder() {
      console.log("onQuestionEndOrder: " + JSON.stringify(this.formModal.questionnaireLangList))
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList.map((questionnaireLangItem, index) => {
        if (index !== 0) {
          const newList = []
          for (let i = 0; i < this.formModal.questionnaireLangList[0].questions.length; i ++) {
            const idx = this.formModal.questionnaireLangList[0].questions[i].index
            // eslint-disable-next-line array-callback-return
            questionnaireLangItem.questions.map(item => {
              if (item.index === idx) {
                newList.push(item)
              }
            })
          }
          this.formModal.questionnaireLangList[index].questions = newList
        }
      })
    },
    callSetQuestionOrder () {
      let ordersStr = ""
      // eslint-disable-next-line array-callback-return
      this.formModal.questionnaireLangList[0].questions.map(item => {      
        if (item.id !== "" && item.id !== "0" && item.id !== 0)   {
          if (ordersStr === "") {
            ordersStr = item.id
          } else {
            ordersStr = ordersStr + "," + item.id
          }        
        }
      })
      const rq = {
        "#request" : DibbleAPI.api.questionnaire.setQuestionsOrder,
        questionnaire_id: this.formModal.questionnaire_id,
        question_ids: ordersStr
      }
      console.log("callSetQuestionOrder: " + JSON.stringify(rq)) 
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()
          console.log(data.message)
          if (DibbleAPI.isResponseSuccess(data)) {
            DibbleJS.toastSuccessMessage(data.message)   
          } else {
            DibbleJS.toastErrorMessage(data.message)
          }
        }
      )
    },
    checkQuestionItemMove () {    
      // eslint-disable-next-line array-callback-return
      this.formEditQuestionModal.questions.map((item, index) => {
        if (item.field_index < index) {
          this.callUpdateQuestionIndex(item, true)
        } else if (item.field_index < index) {
          this.callUpdateQuestionIndex(item, false)
        }
      })
    },    
    callUpdateQuestionIndex (questionItem, isBack) {
      const rq = {
        "#request" : DibbleAPI.api.questionnaire.changeFieldOrderIndex,
        questionnaire_id: this.formEditQuestionModal.questionnaire_id,
        field_id: questionItem.field_id,
        change_position: isBack ? 1 : -1
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()
          console.log(data.message)
          if (DibbleAPI.isResponseSuccess(data)) {
            this.isOpenEditQuestionModal = false            
          } else {
            DibbleJS.toastErrorMessage(data.message)
          }
        }
      )
    },
    handleSearch(date, selectedStatus, searchName) {
      const timeStart = new Date(date.startDate).getTime();
      const timeEnd = new Date(date.endDate).getTime();
      // eslint-disable-next-line array-callback-return
      this.listQuestionnareToSort = this.listQuestionnare.filter((el) => {
        const time = new Date(el.creation_date).getTime();
        const conditionTime =
          timeEnd && timeStart ? timeStart < time && time < timeEnd : true;
        const conditionReport =
          selectedStatus !== null ? el.is_active === selectedStatus : true;
        if (
          conditionTime &&
          conditionReport &&
          el.questionnaire_name.includes(searchName)
        ) {
          return el;
        }
      });
    },
    toggleActiveQuesionnaire(item) {
      const rq = {
        "#request" : DibbleAPI.api.questionnaire.setQuestionActive,
        questionnaire_id: item.questionnaire_id,
        is_active: !item.is_active
      }
      DibbleJS.showLoader()
      DibbleJS.callApiRequest(
        rq,
        (data) => {
          DibbleJS.hideLoader()
          if (DibbleAPI.isResponseSuccess(data)) {
            this.getListQuestionnare()
          } else {
            DibbleJS.toastErrorMessage(data.message)
          }
        }
      )           
    },
    openPopupAddQuestionnaire () {
      this.formModal.isOpen = true
      this.formModal.questionnaire_name = ''
      this.formModal.questionnaire_description = ''
      this.formModal.is_active = false
      this.formModal.typeModal = "New"
      this.formModal.questionnaireLangList = [
        {
            id: 1,
            title: "",
            description: "",
            language: "en",
            questions: [
              {
                id: 1,
                content: "",
                index: 1
              }
            ]
          }
      ]
    },
    openPopupEditQuestionnaire (data) {
      this.formModal.isOpen = true
      this.formModal.typeModal = "Edit"
      this.formModal.questionnaire_id = data.questionnaire_id
      this.formModal.questionnaireLangList = []
      // eslint-disable-next-line array-callback-return
      data.langs.map((item, index) => {
        const questionList = []
        // eslint-disable-next-line array-callback-return
        data.questions_order.map((orderItem, idx) => {
          if (orderItem !== "0" && orderItem !== "" && orderItem !== 0) {
            questionList.push({
                id: orderItem,
                content: data.questions[orderItem][data.langs[index]],
                index: idx
            })
          }
        })
        this.formModal.questionnaireLangList.push (
          {
            id: index,
            title: data.subject[data.langs[index]],
            description: data.description[data.langs[index]],
            language: data.langs[index],
            questions: questionList
          }
        )
        console.log("questionnaireLangListL " + JSON.stringify(this.formModal.questionnaireLangList))
      } )
    },
    closePopupAddQuestion () {
      this.formModal.isOpen = false
    },    
  },
};
</script>

<style lang="scss">
.text-username {
  cursor: pointer;
  color: blue;
  &:hover {
    font-style: italic;
  }
}
</style>
